import React, { createContext, useCallback } from 'react'
import { useLocalStorage } from 'usehooks-ts'

interface NumberFormatContextType {
  useDecimals: boolean
  toggleUseDecimals: () => void
}

const initialContext: NumberFormatContextType = {
  useDecimals: true,
  toggleUseDecimals: () => {},
}

export const NumberFormatContext = createContext(initialContext)

const NumberFormatProvider: React.FC = ({ children }) => {
  const [useDecimals, setUseDecimals] = useLocalStorage<boolean>(
    'usingDecimals',
    true
  )

  const toggleUseDecimals = useCallback(() => {
    setUseDecimals((prev) => !prev)
  }, [])

  const contextValue: NumberFormatContextType = {
    useDecimals,
    toggleUseDecimals,
  }

  return (
    <NumberFormatContext.Provider value={contextValue}>
      {children}
    </NumberFormatContext.Provider>
  )
}

export default NumberFormatProvider
